import auth from '../../services/auth'
import jwtDecode from 'jwt-decode'
import { LOGIN, LOGOUT } from '../mutation-types'

const state = {
  token: ''
}

const mutations = {
  [LOGIN] (state, data) {
    state.token = data
    auth.setToken(data)
  },
  [LOGOUT] (state) {
    state.token = null
    auth.setToken(null)
  }
}

const getters = {
  isLoggedIn: state => {
    return state.token !== '' && state.token !== 'undefined' && state.token !== null
  },
  userData: state => {
    if (!state.token) {
      return null
    }
    let decoded = jwtDecode(state.token)
    if (!decoded) {
      return null
    }
    let context = decoded.context
    if (!context) {
      return null
    }
    return {
      username: context.username
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js